import {
  Card,
  Flex,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react';
import {
  TableData,
  TableRowDataValue,
} from '@client/graphql/__generated__/types';
import { DataSourceTooltip } from '../ListingPageContent/DataSource/DataSourceTooltip';
import { useListingPageContext } from '../ListingPageContext';
import { MetricCardEmptyState } from '../ListingPageMetrics/Card/MetricCardEmptyState';
import { METRIC_CARD_MIN_HEIGHT } from '../ListingPageMetrics/constants';

export const ListingPageKeyTermsTable = ({
  tableData,
  showEmptyState,
}: {
  tableData: TableData;
  showEmptyState?: boolean;
}) => {
  const { confidence } = useListingPageContext();

  return (
    <Flex
      direction="column"
      gap={4}
      height={{ base: '100%', md: 'auto' }}
      width="100%"
    >
      <Flex alignItems="center" justifyContent="space-between">
        <Text fontSize={{ base: 'lg', md: 'xl' }} fontWeight="medium">
          {tableData.title}
        </Text>
        {!!confidence && <DataSourceTooltip />}
      </Flex>
      <Card
        height={showEmptyState ? METRIC_CARD_MIN_HEIGHT : 'auto'}
        overflow="hidden"
        width="100%"
      >
        {showEmptyState ? (
          <MetricCardEmptyState />
        ) : (
          <Flex minHeight={0} minWidth={0} overflow="auto" width="100%">
            <Table size={{ base: 'sm', md: 'md', xl: 'lg' }}>
              <Thead bg="whiteAlpha.100">
                <Tr>
                  <Th /> {/* for the  column */}
                  {tableData.columns.map((column) => (
                    <Th
                      key={column.key}
                      bg={column.isHighlighted ? 'whiteAlpha.100' : undefined}
                      whiteSpace="nowrap"
                    >
                      <Text fontWeight="medium">{column.title}</Text>
                      {!!column.summary && (
                        <Text
                          bg="purpleGradient"
                          bgClip="text"
                          fontSize="sm"
                          fontWeight="normal"
                        >
                          {column.summary}
                        </Text>
                      )}
                    </Th>
                  ))}
                </Tr>
              </Thead>
              <Tbody>
                {tableData.rows.map((row) => (
                  <Tr key={row.title}>
                    <Td
                      borderRight="1px solid"
                      borderRightColor="whiteAlpha.200"
                    >
                      <Text
                        color="whiteAlpha.600"
                        fontSize="sm"
                        fontWeight="medium"
                      >
                        {row.title}
                      </Text>
                    </Td>
                    {tableData.columns.map((column) => {
                      const rowData = row.data?.[
                        column.key
                      ] as TableRowDataValue;

                      return (
                        <Td
                          key={column.key}
                          bg={
                            column.isHighlighted ? 'whiteAlpha.100' : undefined
                          }
                        >
                          <Text fontWeight="medium">{rowData?.value}</Text>
                          {!!rowData?.subValue && (
                            <Text
                              color="whiteAlpha.600"
                              fontSize="sm"
                              fontWeight="normal"
                            >
                              {rowData?.subValue}
                            </Text>
                          )}
                        </Td>
                      );
                    })}
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </Flex>
        )}
      </Card>
    </Flex>
  );
};
